import { useEffect } from 'react';

type UseModalEscapeProps = {
  isOpen: boolean;
  onClose: () => void;
}

const useModalEscape = ({ isOpen, onClose }: UseModalEscapeProps) => {
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);

      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);

      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (scrollY) {
        window.scrollTo(0, -parseInt(scrollY, 10));
      }
    };
  }, [isOpen, onClose]);
}

export default useModalEscape;